import { Plan, PlanExtraDetail } from '@dtx-company/true-common/src/types/Plan'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { Subscription } from '@dtx-company/inter-app/src/types/subscription'
import { useBuyPlanPagePlanExtras } from './useBuyPlanPagePlanExtras'
import { useEffect, useState } from 'react'

interface BuyPlanPageOtherPlanExtrasProps {
  planType?: PlanType
  currentSubscriptionInfoData?: Subscription | null | undefined
  selectedPlan?: Plan
}

/*  Checks the plan extras and returns the plan extra details (which is a subset of the planExtra that 
  only includes the planExtraId and quantity used to create a subscription) belonging to plan extras 
  that have a type other than seats. This hook exists to make sure that if BE adds a new plan extra, 
  the checkout flow doesn't break in between when it's added and when FE adds support for it.
*/
export function useBuyPlanPageOtherPlanExtras({
  planType,
  currentSubscriptionInfoData,
  selectedPlan
}: BuyPlanPageOtherPlanExtrasProps): {
  restPlanExtraDetails: PlanExtraDetail[]
} {
  const [restPlanExtraDetails, setRestPlanExtraDetails] = useState<PlanExtraDetail[]>([])

  const planExtras = useBuyPlanPagePlanExtras({
    planType,
    currentSubscriptionInfoData,
    selectedPlan
  })

  // provides functionality if BE adds other plan extras
  useEffect(() => {
    if (!planExtras) return
    planExtras.forEach(planExtra => {
      if (planExtra.planExtraType !== 'seats') {
        setRestPlanExtraDetails(prevRestPlanExtraDetails => [
          ...prevRestPlanExtraDetails,
          {
            planExtraId: planExtra.planExtraId,
            quantity: planExtra.currentQuantity
          }
        ])
      }
    })
  }, [planExtras])

  return {
    restPlanExtraDetails
  }
}
